import gql from 'graphql-tag';

export const SKIN_TYPE_CONCERN_TAGS = gql`
  query skinTypeConcernTags($first: Int, $skinType: String, $skinConcern: String) {
    skintypeConcernTags(first: $first, skinType: $skinType, skinConcern: $skinConcern) {
      totalCount
      edges {
        node {
          id
          tag {
            id
            name
          }
        }
      }
    }
  }
`;
